module.exports = __webpack_public_path__ + "assets/img/1-1-en.4111c07b.png";